var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.vulnerabilities === 0
    ? _c(
        "span",
        { staticClass: "progress" },
        [
          _c(
            "b-progress",
            {
              staticClass: "table-progress",
              attrs: { max: "0", "show-value": "" },
            },
            [
              _c("b-progress-bar", {
                staticClass: "table-progress text-dark",
                attrs: { value: "0" },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "span",
        { staticClass: "progress" },
        [
          _c(
            "span",
            {
              staticClass: "table-progress",
              attrs: { id: "progressbar" + _vm.hoverId },
            },
            [
              _c(
                "b-progress",
                {
                  staticClass: "table-progress",
                  attrs: { max: _vm.vulnerabilities, "show-value": "" },
                },
                [
                  _c("b-progress-bar", {
                    staticClass: "severity-critical-bg",
                    attrs: { value: _vm.critical },
                  }),
                  _c("b-progress-bar", {
                    staticClass: "severity-high-bg text-dark",
                    attrs: { value: _vm.high },
                  }),
                  _c("b-progress-bar", {
                    staticClass: "severity-medium-bg text-dark",
                    attrs: { value: _vm.medium },
                  }),
                  _c("b-progress-bar", {
                    staticClass: "severity-low-bg",
                    attrs: { value: _vm.low },
                  }),
                  _c("b-progress-bar", {
                    staticClass: "severity-unassigned-bg",
                    attrs: { value: _vm.unassigned },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tooltip",
            {
              attrs: {
                target: "progressbar" + _vm.hoverId,
                placement: "left",
                noninteractive: "",
              },
            },
            [
              _c("div", { staticStyle: { "text-align": "left" } }, [
                _c("h5", [_vm._v(_vm._s(_vm.$t("message.severity")))]),
                _c("p", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("severity.critical")) +
                      ": " +
                      _vm._s(_vm.critical)
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("severity.high")) +
                      ": " +
                      _vm._s(_vm.high)
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("severity.medium")) +
                      ": " +
                      _vm._s(_vm.medium)
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("severity.low")) +
                      ": " +
                      _vm._s(_vm.low)
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("severity.unassigned")) +
                      ": " +
                      _vm._s(_vm.unassigned)
                  ),
                  _c("br"),
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("message.total")) +
                    ": " +
                    _vm._s(_vm.vulnerabilities) +
                    "\n    "
                ),
              ]),
            ]
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }